export default () => ({
  data: {},
  biddingAdviserValue: undefined,
  refreshKey: 0,

  translatedDescription: undefined,
  translatedDefectsDescription: undefined

})
